import { PageContainer } from '@/components'
// import { Main } from './main'
import TaskListMain from './task-list-main'
const TaskList = () => (
  <PageContainer>
    <TaskListMain />
  </PageContainer>
)
export default TaskList
